/**
 * Minimalerei Member Page FAQ — Phase 4.2
 *
 * Akkordeon Open/Close. Multi-Open: mehrere Items dürfen gleichzeitig
 * geöffnet sein (bewusst — User wollen Antworten oft vergleichen).
 *
 * Animation läuft via CSS max-height-Transition; das JS toggelt nur
 * die `.is-open`-Klasse + aria-Attribute. Initial-State kommt vom
 * Server-Side-Render (default_open-Setting) — JS muss nicht initial
 * greifen.
 */

(function () {
  'use strict';

  function initFaq(faqSection) {
    const items = faqSection.querySelectorAll('[data-mp-faq-item]');
    if (!items.length) return;

    items.forEach(function (item) {
      const toggle = item.querySelector('[data-mp-faq-toggle]');
      const answer = item.querySelector('[data-mp-faq-answer]');
      if (!toggle || !answer) return;

      toggle.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        if (isOpen) {
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          answer.setAttribute('aria-hidden', 'true');
        } else {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-mp-member-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
